import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormValueControl } from '@angular/forms/signals';
import { NgIcon } from '@ng-icons/core';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { PasswordModule } from 'primeng/password';

@Component({
  selector: 'app-input-password',
  imports: [
    PasswordModule,
    InputGroupModule,
    FormsModule,
    InputGroupAddonModule,
    NgIcon,
  ],
  templateUrl: './input-password.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputPassword implements FormValueControl<string> {
  inputID = input<string>();
  label = input<string>();
  edit = input<boolean>(false);
  icon = input<string>();
  placeholder = input<string>();

  value = model('');

  readonly resolvedId = computed(() => {
    return this.inputID() ?? `input-${crypto.randomUUID()}`;
  });
}
